import React from "react"
import { Modal, Button, Table } from "react-bootstrap"
import { getSale, cancelSale } from "../../../../../api/sales"
import styled from "styled-components"
import {
    formatCurrencyValue,
    formatDocument,
    formatDate,
    decimalFormat,
    donwloadBase64,
    showSnackBar
} from "../../../../../utils"
import { getNFeBase64 } from "../../../../../api/nfe"
import LoadingContainer from "../../../../../_components/LoadingContainer"

const PrinterModelButton = styled(Button)`
    border-radius: 10px
`

const SALE_STATUS = {
    "2": <div className="badge badge-primary">Confirmada</div>,
    "3": <div className="badge badge-dark">Cancelada</div>,
}
const PAYMENT_STATUS = {
    "1": <div className="badge badge-primary">Confirmada</div>,
    "2": <div className="badge badge-dark">Cancelado</div>,
}

export default props => {

    const [sale, setSale] = React.useState({ items: [], payments: [] })
    const [loading, setLoading] = React.useState(false)
    const [screenWidth, setWidth] = React.useState(window.innerWidth);

    const isMobile = screenWidth <= 768;


    function getBranchData() {
        let branch = window.localStorage.getItem("easygestorweb_current_branch")
        if (branch) {
            return JSON.parse(branch)
        }
        return {}
    }
    async function getSaleDetails() {
        setLoading(true)
        const id = window.location.pathname.split("/sale/")[1]

        setTimeout(async () => {
            await getSale(id)
                .then(obj => {
                    obj.created_date = formatDate(obj.created_date)
                    if (obj.cancel_date) {
                        obj.cancel_date = formatDate(obj.cancel_date)
                    }
                    obj.total = decimalFormat(obj.total_amount - obj.discount_value)
                    obj.total_amount = formatCurrencyValue(obj.total_amount)
                    obj.discount_value = formatCurrencyValue(obj.discount_value)
                    obj.total = formatCurrencyValue(obj.total)
                    obj.change = formatCurrencyValue(obj.change || 0)
                    obj.allowCancel = true
                    obj.allowCancelButtonText = "Cancelar Venda"
                    obj.requestingCancelSale = false
                    if (obj.nfce_key) {
                        obj.allowCancel = obj.nfce_allow_cancel
                        if (!obj.nfce_allow_cancel) {
                            obj.allowCancelButtonText = "NFCe fora do prazo de cancelamento"
                        }
                    }
                    if (obj.status === 3) {
                        obj.allowCancel = false
                        obj.allowCancelButtonText = "Esta venda está cancelada"
                    }
                    if (obj.cancel_date) {
                        obj.cancel_date = formatDate(obj.cancel_date)
                    }
                    setSale(obj)
                    setLoading(false)
                    window.scrollTo({ top: 0 })
                })
                .catch(error => {
                    setLoading(false)
                })
        }, 1000)
    }
    function A4Printer() {
        const sideBarEl = document.querySelector(".navbar-static-side")
        const printerSection = document.getElementById("sale-details-printer-section")
        const printerSectionHeader = document.getElementById("sale-details-printer-section-header")
        const navBarTop = document.querySelector(".navbar-static-top")
        const footer = document.querySelector(".footer")

        sideBarEl.style.display = "none"
        navBarTop.style.display = "none"
        printerSection.classList.add("d-none")
        printerSectionHeader.classList.add("d-none")
        footer.classList.add("d-none")
        print()
        sideBarEl.style.display = "block"
        navBarTop.style.display = "block"
        printerSection.classList.remove("d-none")
        printerSectionHeader.classList.remove("d-none")
        footer.classList.remove("d-none")

    }
    function NonFiscalPrinter() {
        const branch = getBranchData()
        if (branch.company) {
            branch.name = branch.company.fancy_name
            branch.cpf_cnpj = branch.company.cnpj
        } else {
            branch.cpf_cnpj = branch.individual.cpf
        }
        branch.cpf_cnpj = formatDocument(branch.cpf_cnpj)
        let { address } = branch
        address = `${address.street}, n° ${address.street_number || "S/N"} ${address.district} - ${address.city}/${address.state}`

        let nonFiscalWindow = window.open("", "MsgWindow", "width=350px,height=900px");

        let totalItems = sale.items.reduce((acc, nxt) => {
            return acc + nxt.quantity * nxt.price
        }, 0)
        totalItems = formatCurrencyValue(totalItems)
        const total = formatCurrencyValue(sale.total_amount)

        let client = ""

        if (sale.client_name) {
            client = `<div style="padding-bottom:10px">
            <table style='width:350px;font-size:15px'>
              <tbody>
                <tr>
                  <td><center><b>Consumidor</b></center></td>
                </tr>
                <tr>
                  <td><center><b>Nome: ${sale.client_name}</b></center></td>
                </tr>
              </tbody>
            </table>
          </div>`
        }

        nonFiscalWindow.document.write(`<div style='padding-top: 10px;font-family:gulimche;font-size: 15px;width:350px'>
        <div style='width:350px;height:77px'>
          <b> ${branch.name} <br />
            CPF/CNPJ - ${branch.cpf_cnpj}<br />
            ${address}
          <b>
        </div>

        <div style="padding-bottom:10px">
          <table style='width:350px;font-size:15px'>
            <tbody>
              <tr style='margin-bottom:0'>
                <td><b>Cod.</b> </td>
                <td><b>Item</b> </td>
                <td><center><b>Qtd</b><center></td>
                <td><center><b>Val.</b></center></td>
                <td style='float:right;padding-right:10px'><b>Total</b> </td>
                ${sale.items.map((item, index) => {
            const price = formatCurrencyValue(item.price)
            const total = formatCurrencyValue(item.price * item.quantity)
            return `<tr>
            <td><b>${item.code}</b></td>
            <td><b>${item.name}</b></td>
            <td><b><center>${item.quantity}</center></b></td>
            <td><b><center>${price}</center></b></td>
            <td style='float:right;padding-right:10px'><b>${total}</b></td>
          </tr>`
        })}
              </tr>
            </tbody>
          </table>
        </div>

        <div style="padding-bottom:10px">
          <table style='width:350px;font-size:15px'>
            <tbody>
              <tr>
                <td><b> Qtd total de itens</b></td>
                <td style='float:right;padding-right:10px'><b>${sale.items.length}</b></td>
              </tr>
              <tr>
                <td><b>Valor total</b> </td>
                <td style='float:right;padding-right:10px'><b>${totalItems}</b></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div style="padding-bottom:10px">
          <table style='width:350px;font-size:15px'>
            <tbody>
              <tr>
                <td><b>Formas de Pagamento</b> </td>
                <td style='float:right;padding-right:10px'><b>Valor Pago</b> </td>
              </tr>
              ${sale.payments.map((payment, index) => {
            const value = formatCurrencyValue(payment.value)
            return `<tr>
            <td><b>${payment.name}</b></td>
            <td style='float:right;padding-right:10px'><b>${value}</b></td>
        </tr>`
        })}
            </tbody>
          </table>
        </div>

        <div style="padding-bottom:10px">
          <table style='width:350px;font-size:15px'>
            <tbody>
              <tr>
                <td><b>Desconto</b></td>
                <td style='float:right;padding-right:10px'><b>${sale.discount_value}</b></td>
              </tr>
              <tr>
                <td><b>Total Pago</b></td>
                <td style='float:right;padding-right:10px'><b>${total}</b></td>
              </tr>
              <tr>
                <td><b>Troco</b></td>
                <td style='float:right;padding-right:10px'><b>${sale.change}</b></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div style="">
            ${client}
        </div>
    </div>`)
        nonFiscalWindow.document.title = ""
        nonFiscalWindow.focus()
        nonFiscalWindow.print()
    }
    async function getNFCeBase64() {
        try { document.getElementById("download-nfce-files-from-invoice").classList.remove("d-none") } catch (error) { }
        setSale({ ...sale, loadingNFCeData: true, nfceShowModal: true })
        await getNFeBase64({ document: "nfce", key: sale.nfce_key })
            .then(data => {
                setSale({ ...sale, loadingNFCeData: false, ...data, nfceShowModal: true })
            })
            .catch(error => {
                showSnackBar("Não foi possível acessar os dados da NFCe")
                setSale({ ...sale, loadingNFCeData: false, nfceShowModal: true })
                try { document.getElementById("download-nfce-files-from-invoice").classList.add("d-none") } catch (error) { }
                if (error.partner_error) {
                    setTimeout(() => {
                        showSnackBar(error.partner_error)
                    }, 2000)
                }
            })

    }
    function download(filetype) {
        const data = sale[filetype]
        setSale({ ...sale, downloadingNFCeFile: true })
        donwloadBase64(sale.nfce_key, filetype, `application/${filetype}`, data)
        setSale({ ...sale, downloadingNFCeFile: false })
        showSnackBar("Download finalizado", "info")
    }
    function closeModalDownLoadNFCe() {
        setSale({ ...sale, loadingNFCeData: false, nfceShowModal: false })
    }
    function showModalCancelSale() {
        if (sale.requestingCancelSale) {
            return
        }
        setSale({ ...sale, showModalCancelSale: true })
    }
    function closeModalCancelSale() {
        setSale({ ...sale, showModalCancelSale: false })
    }
    async function onCancelSale() {
        setSale({ ...sale, showModalCancelSale: true, requestingCancelSale: true })

        await cancelSale(sale.id)
            .then(() => {
                window.location.reload()
            })
            .catch(error => {
                if (error.error) {
                    alert(error.error)
                }
                setSale({ ...sale, showModalCancelSale: true, requestingCancelSale: false })
            })
    }

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    React.useEffect(() => {
        window.addEventListener("resize", handleWindowSizeChange);
        // Função de limpeza para remover o ouvinte de eventos.
        return () => {
            window.removeEventListener("resize", handleWindowSizeChange);
        };
    }, []);

    React.useEffect(getSaleDetails, [])

    return <LoadingContainer loading={loading}>
        <div className="row">
            <div className="col-12">
                <h2>
                    Fatura
                </h2>
                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Situação</th>
                            <th>Data da Venda</th>
                            {
                                sale.status === 3
                                    ? <th>Data de Cancelamento</th>
                                    : <span />
                            }
                            <th>Total</th>
                            <th>Desconto</th>
                            <th>Cliente</th>
                            <th>Vendedor</th>
                            <th>Total da Venda</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{sale.code}</td>
                            <td>{SALE_STATUS[sale.status]}</td>
                            <td>{sale.created_date}</td>
                            {
                                sale.status === 3
                                    ? <td>{sale.cancel_date}</td>
                                    : <span />

                            }
                            <td>{sale.total_amount}</td>
                            <td>{sale.discount_value}</td>
                            <td>{sale.client_name}</td>
                            <td>{sale.username}</td>
                            <td>{sale.total}</td>
                        </tr>
                    </tbody>
                </Table>
            </div>
        </div>
        <div className="row">
            <div className="col-12">
                <h2>
                    Itens
                </h2>
                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Item</th>
                            <th>Cód./Cód. Barras</th>
                            <th>Quantidade</th>
                            <th>Preço de venda</th>
                            <th>Preço de Unititário</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            sale.items.map((item, index) => {
                                let total = formatCurrencyValue(item.price * item.quantity)
                                const price = formatCurrencyValue(item.price)

                                return <tr>
                                    <td>{index + 1}</td>
                                    <td>{item.name}</td>
                                    <td>{item.code}</td>
                                    <td>{item.quantity}</td>
                                    <td>{price}</td>
                                    <td>{price}</td>
                                    <td>{total}</td>
                                </tr>
                            })
                        }
                    </tbody>
                </Table>
            </div>
            <div className="col-12">
                <h2>
                    Pagamentos
                </h2>
                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Forma de pagamento</th>
                            <th>Situação</th>
                            <th>Data</th>
                            <th>Valor Pago</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            sale.payments.map((payment, index) => {

                                let value = decimalFormat(payment.value, 2)
                                value = formatCurrencyValue(value)
                                const created_date = formatDate(payment.created_date)

                                return <tr>
                                    <td>{index + 1}</td>
                                    <td>{payment.name}</td>
                                    <td>{PAYMENT_STATUS[payment.status]}</td>
                                    <td>{created_date}</td>
                                    <td>{value}</td>
                                </tr>
                            })
                        }
                    </tbody>
                </Table>
            </div>
            <div className="col-12 my-3" id="sale-details-printer-section-header">
                <PrinterModelButton
                    disabled={!sale.allowCancel}
                    onClick={showModalCancelSale}
                    variant="danger">
                    {sale.allowCancelButtonText}
                </PrinterModelButton>
                <h2>
                    Impressão
                </h2>
            </div>
            <div className={isMobile ? "col-md-4 col-xs-12 mb-5 pb-5" : "col-md-4 col-xs-12"} id="sale-details-printer-section" >
                <div className="d-flex justify-content-between">
                    <PrinterModelButton
                        onClick={A4Printer}
                        className="px-4">
                        <strong>
                            A4
                        </strong>
                    </PrinterModelButton>
                    <PrinterModelButton
                        onClick={NonFiscalPrinter}
                        className="px-4">
                        <strong>
                            40COL (Não Fiscal)
                        </strong>
                    </PrinterModelButton>
                    {
                        sale.nfce_key
                            ? <PrinterModelButton onClick={getNFCeBase64}>
                                <strong>
                                    NFC-e
                                </strong>
                            </PrinterModelButton>
                            : <span />
                    }
                </div>
            </div>
        </div>
        <Modal show={sale.nfceShowModal} size="lg" onHide={closeModalDownLoadNFCe}>
            <Modal.Header closeButton>
                <Modal.Title>
                    Arquivos
                </Modal.Title>
            </Modal.Header>
            <LoadingContainer loading={sale.loadingNFCeData}>
                <Modal.Body>
                    <p className="lead" id="modal-download-nfce-files-title">
                        Clique no botão abaixo para baixar o arquivo
                    </p>
                    <div id="download-nfce-files-from-invoice">
                        <Button
                            disabled={sale.downloadingNFCeFile}
                            onClick={() => download("pdf")}
                            title="PDF" >
                            <i className="fa fa-file-pdf dim"></i>
                        </Button>
                        <Button
                            disabled={sale.downloadingNFCeFile}
                            title="XML"
                            onClick={() => download("xml")}
                            className="ml-4">
                            <i className="fas fa-code dim"></i>
                        </Button>
                    </div>
                </Modal.Body>
            </LoadingContainer>

        </Modal>
        <Modal show={sale.showModalCancelSale} onHide={closeModalCancelSale}>
            <Modal.Header closeButton>
                <Modal.Title>
                    Cancelar Venda
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="lead">
                    Esta venda será permanentemente cancelada
                </p>
                <p className="text-center"> </p>
                <div className="d-flex justify-content-center">
                    <Button
                        disabled={sale.requestingCancelSale}
                        onClick={onCancelSale} >
                        Cancelar venda
                    </Button>
                </div>
                <LoadingContainer loading={sale.requestingCancelSale} />
            </Modal.Body>
        </Modal>
    </LoadingContainer>

}


// WEBPACK FOOTER //
// ./src/views/AppViews/POS/components/Invoice/index.jsx